import axios from 'axios'
import router from '../router';
import { Message } from 'element-ui'
import i18n from '../i18n'
import { getRefreshToken, saveTokens } from './auth.js'
import { getClientDeviceId } from './clientDevice.js'
import endpointManager from './endpointManager.js'

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 30
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	const isUpload = /\/(image|file|video)\/upload/.test(String(config.url || ''));
	config.baseURL = isUpload ? endpointManager.getUploadBase() : endpointManager.getApiBase();
	const accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	// 国际化：后端根据此 header 返回对应语言的消息
	const locale = i18n.locale;
	config.headers['Accept-Language'] = locale;
	config.headers['X-Locale'] = locale;
	config.headers['X-Device-Id'] = getClientDeviceId();
	config.headers['X-Device-Info'] = encodeURIComponent(`${navigator.platform || 'web'} | ${navigator.userAgent}`);
	config.headers['X-Client-Terminal'] = '0';
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	endpointManager.markSuccess();
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		const refreshToken = getRefreshToken();
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
			return Promise.reject(response.data);
		})
		saveTokens(data);
		response.config.headers.accessToken = encodeURIComponent(data.accessToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, async error => {
	const status = error.response && error.response.status;
	const method = String(error.config && error.config.method || 'get').toLowerCase();
	const lineFailure = !status || [502, 503, 504].includes(status);
	if (lineFailure) {
		const switched = await endpointManager.markFailure();
		if (switched && ['get', 'head', 'options'].includes(method) && error.config && !error.config.__lineRetry) {
			error.config.__lineRetry = true;
			error.config.baseURL = endpointManager.getApiBase();
			return http(error.config);
		}
	}
	switch (status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			exit();
			break
		case 405:
			Message({
				message: i18n.t('http.methodError'),
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: i18n.t('http.serverError'),
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: i18n.t('http.notSupport'),
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}
	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
